import React, { useState } from "react";
import { BsChevronDoubleUp, BsChevronDoubleDown } from "react-icons/bs";
import QuickDictionaryLookup from "./QuickDictionaryLookup";


const BottomBar = () => {
    const [activeTab, setActiveTab] = useState("home");
    const [open, setOpen] = useState(false);
    const [selectedText, setSelectedText] = useState("");
    const [loading, setLoading] = useState(false);

    const handleDictionaryClick = async () => {
        const text = window.getSelection().toString().trim();

        if (!text) {
            alert("Please select a word first.");
            return;
        }

        setSelectedText(text);
        setOpen(true);

    };

    return (
        <>
            <div
                className={`fixed bottom-0 left-0 right-0 bg-white text-black transform ease-in-out z-[9999]
        border-t-2 border-gray-300 shadow-[-10px_0_25px_-5px_rgba(0,0,0,0.25)] transition-all duration-300 
        ${open ? "h-[250px]" : "h-[40px]"}`}
            >
                {/* Top Row */}
                <div className="h-[40px] flex items-center justify-between px-6">
                    <div className="flex gap-4 font-medium">
                        <button
                            onClick={() => {
                                setActiveTab("dictionary");
                                handleDictionaryClick();
                            }}
                            className={`transition ${activeTab === "dictionary"
                                ? "text-green-600 font-semibold"
                                : "hover:text-gray-600"
                                }`}
                        >
                            Dictionary
                        </button>
                        <button
                            onClick={() => setActiveTab("spellCheck")}
                            className={`transition ${activeTab === "spellCheck"
                                ? "text-green-600 font-semibold"
                                : "hover:text-gray-600"
                                }`}
                        >
                            SpellCheck
                        </button>
                        <button
                            onClick={() => setActiveTab("tm")}
                            className={`transition ${activeTab === "tm"
                                ? "text-green-600 font-semibold"
                                : "hover:text-gray-600"
                                }`}
                        >
                            TM
                        </button>
                    </div>

                    <button
                        onClick={() => setOpen(!open)}
                        className="text-2xl transition-transform duration-300"
                    >
                        {open ? <BsChevronDoubleUp /> : <BsChevronDoubleDown />}
                    </button>
                </div>

                {open && activeTab === 'dictionary' && (
                    <div className="px-6 py-4 border-t text-sm text-gray-700 space-y-4 max-h-[250px] overflow-y-auto overscroll-contain">
                        <>
                            <div className="mt-0">
                                <QuickDictionaryLookup
                                    initialWord={selectedText}
                                />
                            </div>
                        </>

                    </div>
                )}
                {open && activeTab === 'spellCheck' && (
                    <div className="px-6 py-4 border-t text-sm text-gray-700 space-y-4 max-h-[250px] overflow-y-auto overscroll-contain">
                        <>
                            <p className="font-semibold">{selectedText}</p>
                        </>
                    </div>
                )}


                {/* Expanded Section */}
                {open && activeTab === 'tm' && (
                    <div className="px-6 py-4 border-t text-sm text-gray-700 space-y-4 max-h-[250px] overflow-y-auto overscroll-contain">
                        <>
                            <p className="font-semibold">{selectedText}</p>
                        </>
                    </div>
                )}
            </div>
        </>
    );
};

export default BottomBar;